export default __webpack_public_path__ + "static/media/successIcon2.010473a4.svg";